const setCookie = (key = '', value = '', expiresTime = '', path = '/') => {
  document.cookie = `${key}=${value}; expires=${expiresTime}; path=${path}`
}

const clearCookie = (key = '') => {
  document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path =/`
}

export { setCookie, clearCookie }
